import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
import { createDomain } from '@/services/domain.service'
import executeWithRefresh from '@/composables/useRefresher'
import { useSubmit } from './FormMixin'
import { prop } from 'ramda';


export default /*#__PURE__*/_defineComponent({
  __name: 'add-domain',
  props: ['buyers', 'tds'],
  emits: ['close', 'finish'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const requiredTds = ref('')
const buyersList = ref([])
const tdsList = ref([])

const formData = ref({
  domains: '',
  buyer: null,
  tds: null,
})

const request = async (sendData, control) => {
  const error = (await useSubmit(send(sendData), control, false))
}

const send = async data => {
  const sendData = {
    domains: formData.value.domains,
    buyer: formData.value.buyer?.id,
    tds: formData.value.tds?.id
  }
  try {
    const res = await (executeWithRefresh(createDomain, null, {}, sendData))
    emit('finish', true)
  } catch(e: any) {
    return Promise.reject(e)
  }
}

function onChangeBuyer(el) {
  if(el != undefined) {
    requiredTds.value = 'required'
  }
}

function onClearBuyer(el) {
  formData.value.buyer = null
  requiredTds.value = ''
}

onMounted(() => {
  buyersList.value = props.buyers
  tdsList.value = props.tds
})


const __returned__ = { props, emit, requiredTds, buyersList, tdsList, formData, request, send, onChangeBuyer, onClearBuyer, ref, onMounted, get createDomain() { return createDomain }, get executeWithRefresh() { return executeWithRefresh }, get useSubmit() { return useSubmit }, get prop() { return prop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})